import { countriesWithNoPostalCode } from 'features/billing/modals/tax_information_modal'

/**
 * Validates that checkout form has required country and postal code information
 *
 * @param {string|null|undefined} billingCountry - Country code from checkout
 * @param {string|null|undefined} postalCode - Postal code from checkout
 * @returns {boolean} True if form is ready to submit, false otherwise
 */
export const isCheckoutReadyToSubmit = (billingCountry, postalCode) => {
  if (!billingCountry) {
    return false
  }
  const normalizedCountry = typeof billingCountry === 'string' ? billingCountry.toUpperCase() : billingCountry
  if (countriesWithNoPostalCode.includes(normalizedCountry)) {
    return true
  }
  if (!postalCode?.trim()) {
    return false
  }
  return true
}
